import React, { Component } from "react";
import DatePicker from "react-datepicker";
import FileUpload from "../FileUpload/FileUpload";
import moment from "moment";
import classNames from "classnames";
import "react-datepicker/dist/react-datepicker.css";
import "./Input.css";

export default class Input extends Component {
	state = {
		invalid: false
	};
	constructor(props) {
		super(props);
		this._input = React.createRef();
	}
	componentDidMount() {
		if (this.props.focusOnMount) {
			window.requestAnimationFrame(() => {
				this._input.current.select();
			});
		}
	}
	onBlur = e => {
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
		if (this.props.validate) {
			this.setState({
				invalid: !this.props.validate(this.props.value)
			});
		}
	};
	onFocus = () => {
		if (this.props.validate) {
			this.setState({
				invalid: false
			});
		}
	};
	onCalendarSelect = data => {
		this.props.onChange(data && data.toISOString());
		if (this.props.validate) {
			this.setState({
				invalid: !this.props.validate(data && data.toISOString())
			});
		}
	};
	classes() {
		return classNames({
			"form-input": true,
			[this.props.type]: true,
			"-invalid": this.state.invalid
		});
	}
	render() {
		const { type } = this.props;

		if (type === "checkbox") {
			return (
				<div className={this.classes()}>
				<label className="Input__label">
				<input
				type="checkbox"
				className="Input__checkbox"
				checked={this.props.value}
				onChange={this.props.onChange}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				/>
				{this.props.title}
				</label>
				</div>
			);
		}
		return (
			<div className={this.classes()} style={this.props.styleContainer}>
			{this.props.title && (
				<label className="Input__label">{this.props.title}{this.state.invalid && this.props.required ? <span>&nbsp;&nbsp;*&nbsp;required&nbsp;field</span> : ''}</label>
			)}
			{type === "textarea" ? (
				<textarea
				className="Input__textarea"
				value={this.props.value}
				onChange={this.props.onChange}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				/>
			) : type === "dropdown" ? (
				<select
				style={this.props.style}
				className="Input__dropdown"
				onChange={this.props.onChange}
				value={this.props.value}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				>
				{Object.keys(this.props.options).map(option => (
					<option value={option} key={option}>
					{this.props.options[option]}
					</option>
				))}
				</select>
			) : type === "datepicker" ? (
				<DatePicker
				onChange={this.onCalendarSelect}
				onSelect={this.props.onBlur}
				dateFormat="DD/MM/YYYY"
				selected={
					this.props.value !== "" && moment(this.props.value).isValid()
					? moment(this.props.value)
					: moment("01/07/2004")
				}
				/>
			) : type === "file" ? (
				<FileUpload
				onComplete={this.props.onComplete}
				value={this.props.value}
				filePath={this.props.filePath}
				/>
			) : type === "password" ? (
				<input
				type="password"
				className="Input__input"
				value={this.props.value}
				onChange={this.props.onChange}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				placeholder={this.props.placeholder}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				/>
			) : type === "email" ? (
				<input
				type="email"
				className="Input__email"
				value={this.props.value}
				onChange={this.props.onChange}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				placeholder={this.props.placeholder}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				maxLength={this.props.maxlength}
				/>
			) : (
				<input
				type="text"
				style={this.props.style}
				className="Input__input"
				value={this.props.value}
				onChange={this.props.onChange}
				onBlur={this.onBlur}
				onFocus={this.onFocus}
				placeholder={this.props.placeholder}
				ref={this._input}
				readOnly={this.props.readOnly}
				required={this.props.reqiured}
				maxLength={this.props.maxlength}
				/>
			)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Input/Input.js